import { useCallback } from 'react';
import { GroupMemberRole } from '@group/domain';
import { useTranslation } from 'react-i18next';

type Props = {
  defaultRole: GroupMemberRole;
  onChange(role: GroupMemberRole): void;
  disabled: boolean;
};

export const BasicRoleSelect: React.FC<Props> = ({ defaultRole, disabled, onChange }: Props) => {
  const { t } = useTranslation();
  const handleChangeRole = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(GroupMemberRole.load(event.target.value));
    },
    [onChange]
  );

  return (
    <div>
      <select
        className="form-select m-1 py-1 text-sm"
        defaultValue={defaultRole.toString()}
        onChange={handleChangeRole}
        disabled={disabled}
      >
        {GroupMemberRole.regularValues().map((role) => (
          <option key={role} value={role}>
            {t(GroupMemberRole.getLocalStringKey(role))}
          </option>
        ))}
      </select>
    </div>
  );
};
